var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"dianpu-hot"},[_c('div',{staticClass:"card-list"},[_vm._l((_vm.topCardsComponentList),function(ref,index){
var componentIndex = ref.componentIndex;
var componentNeedData = ref.componentNeedData;
return _c(componentIndex,{key:index,tag:"component",attrs:{"data":componentNeedData},on:{"toggle":_vm.toggle}})}),_vm._l((_vm.listCardsComponentList),function(ref,index){
var componentIndex = ref.componentIndex;
var componentNeedData = ref.componentNeedData;
return _c(componentIndex,{key:index,tag:"component",attrs:{"data":componentNeedData}})})],2)])}
var staticRenderFns = []

export { render, staticRenderFns }